module.exports = __webpack_public_path__ + "img/log_dark_4.6594717d.png";